/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "gambit": {
            "nested": {
              "api": {
                "nested": {
                  "v1": {
                    "nested": {
                      "checkdeposit": {
                        "nested": {
                          "CheckDepositWorkflowState": {
                            "values": {
                              "STATE_UNSPECIFIED": 0,
                              "STATE_INITIATION": 1,
                              "STATE_CHECK_PERCEPTION": 2,
                              "STATE_ACCOUNT_VALIDATION": 3,
                              "STATE_RISK_EVALUATION": 4,
                              "STATE_CHECK_SUBMISSION": 5,
                              "STATE_AWAITING_REVIEW": 6,
                              "STATE_RECEIVED_REVIEW": 12,
                              "STATE_EARLY_FUNDING": 17,
                              "STATE_AWAITING_SETTLEMENT": 16,
                              "STATE_DEPOSIT": 7,
                              "STATE_HOLD_FUNDS": 8,
                              "STATE_COMPLETION": 9,
                              "STATE_DECLINED": 10,
                              "STATE_VOID": 11,
                              "STATE_POST_DEPOSIT_ADJUSTMENT": 13,
                              "STATE_POST_DEPOSIT_VOID": 14,
                              "STATE_INCIDENT_AFFECTED": 15,
                              "STATE_RESTARTED": 18
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.gambit?.nested?.api?.nested?.v1?.nested?.checkdeposit?.nested?.CheckDepositWorkflowState) {
  $root.addJSON(jsonData);
}

/**
 * next id: 19
 *
 * SOURCE CheckDepositWorkflowState @ squareup/cash/gambit/api/v1/checkdeposit/check_deposit_workflow_state.proto at 8:1
 */
export const CheckDepositWorkflowState = $root.lookupEnum('squareup.cash.gambit.api.v1.checkdeposit.CheckDepositWorkflowState').values;